/**
 * ODListableHeader 는 ODListablePaginatedTable 에서 사용하기 위한 컴포넌트이다.
 * 향후 다양한 기능을 추가할 가능성이 있기 때문에 독자 컴포넌트로 분리한다.
 */
import React from 'react';
export function ODListableHeaders(_a) {
    var fields = _a.fields;
    return (React.createElement(React.Fragment, null, fields.map(function (_a) {
        var id = _a.id, title = _a.title, _b = _a.thClass, thClass = _b === void 0 ? 'text-center' : _b, _c = _a.thStyle, thStyle = _c === void 0 ? {} : _c, _d = _a.hide, hide = _d === void 0 ? false : _d;
        return !hide && (React.createElement("th", { key: id, className: thClass, style: thStyle }, title));
    })));
}
//# sourceMappingURL=ODListableHeader.js.map